
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12438',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12438",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.477",
  "data-fetching-client": "static-1.9719",
  "foundations-components": "static-1.8036",
  "foundations-components-legacy": "static-1.1061",
  "foundations-theming": "static-1.4479",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8071",
  "hub-http-shared-msw-handlers": "static-1.10096",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11528",
  "I18n": "static-7.1633",
  "jasmine-runner": "static-1.6518",
  "marketplace-storefront-base": "static-1.12499",
  "quartz": "static-1.7097",
  "react-dlb": "static-1.80",
  "react-rhumb": "static-1.16733",
  "reactive-variable-buffer-atom": "static-1.2913",
  "reporting-testing-lib": "static-1.9725",
  "settings-ui-lib": "static-1.12574",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7241",
  "ui-addon-i18n": "static-1.11206",
  "ui-addon-react-router-dom": "static-1.9596",
  "unified-auth": "static-1.559",
  "unified-auth-core-lib": "static-1.841",
  "usage-tracker": "static-1.7404",
  "usage-tracker-core": "static-1.7254",
  "customer-data-property-utils": "static-1.8148",
  "hub-http": "static-1.6277",
  "integrations-lib": "static-1.16341",
  "marketplace-ui-common": "static-1.19971",
  "property-management-iframe": "static-1.13346",
  "quartz-config": "static-1.875",
  "quartz-core": "static-1.6316",
  "quartz-routing": "static-1.527",
  "quick-fetch": "static-1.3959",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4707",
  "ts-schema": "static-1.4121",
  "ui-universal-auth": "static-1.9045",
  "UIComponents": "static-3.8474",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3441",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3374",
  "quartz-webpack": "static-1.3321",
  "bend-plugin-quartz-routing": "static-1.175",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4305",
  "floating-ui": "static-1.57",
  "foundations-assets": "static-1.4924",
  "foundations-theming-specialty": "static-1.2195",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9478",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.31",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5385",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.488",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2081",
  "ui-fonts": "static-1.790",
  "ui-images": "static-2.1165",
  "bend-plugin-foundations-theming": "static-1.2962",
  "foundations-theming-base": "static-1.3464",
  "stylex": "static-1.34",
  "HeadJS": "static-2.765",
  "hs-test-utils-bend-plugin": "static-1.3182",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4380",
  "ai-components-ui-library": "static-1.9106",
  "ai-rendering-library": "static-1.10360",
  "chirp-fetch": "static-1.1942",
  "connections-embed-lib": "static-1.1099",
  "copilot-toolkit": "static-1.11281",
  "feedback-loader": "static-1.29397",
  "laboratory-lib": "static-3.7210",
  "marketplace-embed": "static-1.22246",
  "marketplace-ui-details": "static-1.9866",
  "marketplace-ui-reviews": "static-1.19926",
  "marketplace-ui-tracking": "static-1.14141",
  "sanitize-text": "static-1.8198",
  "ui-addon-video-player": "static-1.8758",
  "usage-tracker-multi": "static-1.5818",
  "usage-tracker-session-replay": "static-1.5090",
  "wootric-nps": "static-1.7023",
  "quartz-head": "static-1.762",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4706",
  "immer": "static-1.33",
  "immerable": "static-1.4208",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2526",
  "reporting-data": "static-1.67792",
  "cssUtils": "static-1.804",
  "flux-actions": "static-1.341",
  "HubStyle": "static-2.11835",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10264",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10419",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7394",
  "icons": "static-2.650",
  "marketplace-ui-apps-core": "static-1.18503",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4568",
  "foundations-components-test-utils": "static-1.5519",
  "quartz-i18n": "static-1.772",
  "react-input-autosize": "static-2.17",
  "ads-unified-auth-lib": "static-1.69",
  "google-sheets-integration-lib": "static-1.396",
  "microsoft-drive-integration-lib": "static-1.532",
  "slack-ui-library": "static-1.10447",
  "fsm": "static-1.3785",
  "customer-data-objects": "static-1.7732",
  "property-translator": "static-1.5453",
  "hs-locale-management": "static-1.122",
  "frontend-preferences-client": "static-1.7981",
  "hs-promise-utils": "static-1.5646",
  "hubspot-apollo-client": "static-1.4932",
  "integrations-error-boundary-lib": "static-1.13756",
  "integrations-tracking-lib": "static-1.5660",
  "native-integrations-shared-strings": "static-1.7836",
  "reselect": "static-2.16",
  "sanitize": "static-1.4531",
  "superstore": "static-1.4815",
  "ui-shepherd-react": "static-3.10269",
  "ai-settings-ui-library": "static-1.7971",
  "hub-http-janus": "static-1.839",
  "hubspotter-http": "static-1.4692",
  "immutable-less": "static-1.4707",
  "marketplace-ui-client-types": "static-1.17378",
  "nav-meta": "static-1.29809",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10303",
  "ui-addon-upgrades": "static-9.18076",
  "inbound-db-properties-service-client": "static-1.3886",
  "property-management-common": "static-1.5634",
  "ui-addon-iframeable": "static-1.9115",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.772",
  "quartz-test": "static-1.772",
  "quartz-tracking": "static-1.476",
  "trellis-components": "static-1.2100",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.117",
  "bender-build-tools": "static-1.3254",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21540",
  "ContentUtils": "static-1.68525",
  "customer-data-objects-ui-components": "static-1.13087",
  "sassPrefix": "static-1.157",
  "breeze-engine-core": "static-1.128",
  "breeze-onboarding-components": "static-1.147",
  "avatar-components": "static-1.2553",
  "customer-data-filters-ui": "static-1.39989",
  "customer-data-reference-ui-components": "static-1.13224",
  "embedded-academy-lib": "static-1.14524",
  "ExportDialog": "static-6.10440",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41452",
  "reporting-snowflake": "static-1.56410",
  "reporting-ui-components": "static-2.65063",
  "reporting-visualizations": "static-1.59868",
  "ui-addon-teams": "static-1.21629",
  "integrations-reconnect-lib": "static-1.72",
  "magpie-lib": "static-1.5587",
  "navigation-components": "static-1.18172",
  "breeze-engine-lib": "static-1.850",
  "magpie-types": "static-1.5047",
  "simple-logging-lib": "static-1.3105",
  "ai-studio-lib": "static-1.11772",
  "app-governance-lib": "static-1.1727",
  "developer-experience-shared-components": "static-1.10567",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8056",
  "ui-product-approvals": "static-1.28315",
  "ui-tool-access": "static-1.10203",
  "usage-based-billing-components-lib": "static-1.9191",
  "usage-tracker-anonymous": "static-1.5821",
  "usage-tracker-public": "static-1.7215",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3627",
  "persist-promise": "static-1.3753",
  "reference-resolvers": "static-1.8227",
  "ui-extensibility-client-types": "static-1.3980",
  "hubspot-apollo-cache": "static-1.391",
  "universal-page-editor-lib": "static-1.3073",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2931",
  "merchandise-lib": "static-1.265",
  "atom": "static-1.5129",
  "purchase-motions-components": "static-1.6017",
  "salesImages": "static-1.526",
  "batch-promise": "static-1.1596",
  "crm-component-utils": "static-1.39222",
  "crm-properties-common-lib": "static-1.5943",
  "customer-data-properties": "static-1.51771",
  "framework-data-schema-resolvers": "static-1.6944",
  "property-value-citations": "static-1.2385",
  "reference-resolvers-lite": "static-1.8153",
  "ui-business-units-lib": "static-1.9112",
  "navigation-messaging": "static-1.7499",
  "hubspotter-http-shared-msw-handlers": "static-1.10094",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.988",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4867",
  "content-icons-ui": "static-1.2239",
  "customer-data-ui-utilities": "static-1.9880",
  "conversations-skeleton-state": "static-1.7303",
  "crm-message-bus": "static-1.43113",
  "customer-data-filters-ui-msw-helpers": "static-1.22424",
  "events-data-lib": "static-1.284",
  "FormUrlGenerator": "static-2.4775",
  "framework-builder-read-service-client": "static-1.4046",
  "framework-data-schema-quick-fetch": "static-1.6849",
  "multi-account-reference-resolvers": "static-1.1038",
  "onboarding-tours": "static-1.16707",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13836",
  "academy-common-lib": "static-1.13984",
  "content-assistance-lib": "static-1.7836",
  "dashboard-lib": "static-1.81760",
  "file-manager-components": "static-1.23767",
  "getting-started-shared-tasks": "static-1.18573",
  "hubspot-prosemirror": "static-1.18382",
  "hubspot-prosemirror-plugins": "static-1.18374",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19921",
  "share-with-third-party-component-lib": "static-1.8760",
  "ui-addon-draggable": "static-3.4817",
  "ui-asset-management-lib": "static-1.11111",
  "user-context": "static-1.5162",
  "growth-payments-core": "static-1.25535",
  "reporting-plugins": "static-1.10408",
  "reporting-reports": "static-1.67470",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.778",
  "nest": "static-1.287",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10682",
  "framework-listing-lib": "static-2.28839",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30851",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4305",
  "ui-product-approvals-common": "static-1.210",
  "onboarding-scopes": "static-1.6516",
  "onboarding-tours-client": "static-1.4921",
  "platform-infra-nav-components": "static-1.7713",
  "subscription-experience-data-types": "static-1.15005",
  "crm-record-cards-service-types": "static-1.3631",
  "location-customization-utils-lib": "static-1.9419",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6020",
  "signup-constants": "static-1.18967",
  "signup-ui-url-generator": "static-2.8110",
  "card-properties-lib": "static-1.44359",
  "commerce-subscription-lib": "static-1.37276",
  "crm-actions": "static-1.6394",
  "crm-cards-sdk": "static-1.43748",
  "customer-data-properties-shared-msw-handlers": "static-1.9423",
  "customer-data-tracking": "static-1.6944",
  "hs-resources": "static-1.224",
  "pulse": "static-1.642",
  "calling-global-api": "static-1.64710",
  "calling-internal-common": "static-1.31359",
  "calling-lifecycle-internal": "static-1.66092",
  "calling-lifecycle-messages": "static-1.58386",
  "commerce-products-lib": "static-1.9761",
  "conditional-properties-service-client": "static-1.3839",
  "crm-links": "static-1.6362",
  "crm-pipelines-api-client-types": "static-1.4181",
  "external-options-client-types": "static-1.4199",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4264",
  "meetings-icalendar-utils-lib": "static-1.687",
  "multi-currency-client-types": "static-1.3733",
  "object-builder-ui-client": "static-1.48932",
  "pipeline-validation-client-types": "static-1.4007",
  "smart-property-lib": "static-1.7404",
  "tiered-pricing": "static-1.1341",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11044",
  "fdsr-migration-layer": "static-1.63",
  "react-dnd-compat": "static-1.4669",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1032",
  "growth-data-modal": "static-1.5513",
  "growth-onboarding-confetti": "static-1.3121",
  "growth-onboarding-next-action-utils": "static-1.2077",
  "onboarding-tours-utils": "static-1.773",
  "ui-shepherd-tracker": "static-1.7650",
  "academy-service-client": "static-1.3738",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39266",
  "FileManagerLib": "static-1.39407",
  "video-embed": "static-1.35963",
  "ui-coaching-tips": "static-1.28713",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11471",
  "video-data-lib": "static-1.35129",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8519",
  "payment-link-components": "static-1.23657",
  "ui-addon-emoji-picker": "static-1.9941",
  "EmailSignatureEditor": "static-1.24495",
  "viral-links-lib": "static-1.7125",
  "data-token-picker": "static-1.16502",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.281",
  "timezone-utils": "static-2.5298",
  "seat-types-lib": "static-1.145",
  "getting-started-shared-tasks-store": "static-1.17691",
  "ui-addon-opt": "static-4.8417",
  "campaign-roi-lib": "static-1.9256",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25570",
  "framework-data-table": "static-2.12044",
  "marketing-platform-lib": "static-1.6917",
  "nudge-client-utils": "static-1.2702",
  "nudge-custom-ui-functions": "static-1.1132",
  "switchboard-lib": "static-1.277",
  "app-users-service-client": "static-1.5659",
  "app-users-service-types": "static-1.5067",
  "mini-checkout-client": "static-1.26942",
  "onboarding-utils": "static-1.5412",
  "permissions-shared-i18n-strings-fe": "static-1.2054",
  "ui-coaching-tips-shared-config": "static-1.28698",
  "edison-service-client-types": "static-1.444",
  "crm_data": "static-4.92141",
  "customer-data-sidebar": "static-2.46168",
  "enrichment-properties-lib": "static-1.16522",
  "ui-addon-draggable-compat": "static-2.4313",
  "commerce-billing-lib": "static-1.19254",
  "commerce-shared-components-lib": "static-1.18666",
  "commerce-tools-ui-lib": "static-1.10523",
  "crm-fe-perf": "static-1.22957",
  "event-emitter": "static-1.1003",
  "bend-plugin-pulse": "static-1.145",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31366",
  "shared-worker-versioning": "static-1.11091",
  "calling-usage-tracker": "static-1.6596",
  "voice-sms-access-library": "static-1.1221",
  "commerce-permissions": "static-1.829",
  "products-iframe-lib": "static-1.8087",
  "products-ui-components-shared-msw-handlers": "static-1.10478",
  "data-agent-kit": "static-1.281",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10179",
  "policy-lib": "static-1.6833",
  "react-tinymce": "static-1.55395",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10242",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54521",
  "tinymce-plugins": "static-1.57635",
  "tinymce-themes": "static-1.56491",
  "onboarding-data-sync-lib": "static-1.2054",
  "growth-onboarding-next-action-components": "static-1.2105",
  "user-context-client": "static-1.4655",
  "audio-components": "static-1.5995",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36918",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4592",
  "video-components": "static-1.13473",
  "outpost": "static-1.4230",
  "growth-onboarding-feedback-components": "static-1.6634",
  "content-media-composition-data-lib": "static-1.12539",
  "content-media-compositions": "static-2.16546",
  "media-bridge-lib": "static-1.19019",
  "commerce-tours-lib": "static-1.6204",
  "growth-onboarding-reliability": "static-1.5135",
  "sales-checkout-service-client": "static-1.3689",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21770",
  "sales-email-signature-service-client": "static-1.3902",
  "ts-utils-lib": "static-1.226",
  "crm-export-dialog": "static-1.6345",
  "crm-index-associations-lib": "static-1.6497",
  "crm-view-components": "static-1.439",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7383",
  "nudge-custom-function-registry": "static-1.2459",
  "nudge-renderer-utils": "static-1.2778",
  "whisper-core-api": "static-1.6777",
  "InboxConnectUtils": "static-4.14962",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5675",
  "settings-content-modals": "static-1.46242",
  "crm_universal": "static-1.22102",
  "customer-data-email": "static-1.18129",
  "card-payment-highlight-lib": "static-1.37327",
  "card-subscription-highlight-lib": "static-1.39699",
  "commerce-contract-lib": "static-1.12289",
  "invoices-highlight-card-lib": "static-1.54888",
  "orders-highlight-card-lib": "static-1.21618",
  "products-highlight-card-lib": "static-1.18044",
  "quotes-highlight-card-lib": "static-1.72220",
  "crm-source-interpretation-lib": "static-1.5399",
  "utility-belt": "static-1.2589",
  "payments-enrollment-embed-lib": "static-1.23040",
  "stripe-embedded-components": "static-1.7603",
  "customer-data-rte": "static-1.33144",
  "cv-backend-services": "static-1.1555",
  "growth-onboarding-empty-states": "static-1.5838",
  "payments-post-enroll-local-storage-lib": "static-1.5163",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38310",
  "trials-service-types": "static-1.3957",
  "calling-orchestration-schema": "static-1.35998",
  "sales-views-client-types": "static-1.4312",
  "hub-http-contrib": "static-1.3096",
  "interframe": "static-3.4814",
  "tinymce-data": "static-1.40606",
  "ui-addon-sales-email": "static-1.5265",
  "layout-dnd-components": "static-1.12551",
  "layout-dnd-utils": "static-1.11526",
  "ui-brand-identity-lib": "static-1.15493",
  "NamespacedHubStyle": "static-2.9100",
  "meetings-connect-utils-lib": "static-1.7659",
  "social-insights-client-types": "static-1.22241",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4211",
  "checkout-sdk": "static-3.23785",
  "checkout-service-types": "static-1.3846",
  "company-details-components": "static-1.6250",
  "payment-method-components": "static-1.6949",
  "pricing-pages-ui-components": "static-1.14304",
  "quote-checkout-service-types": "static-1.3520",
  "upgrade-catalog-service-types": "static-1.3576",
  "access-control-lib": "static-1.10489",
  "EmailComponents": "static-1.54912",
  "EmailData": "static-1.53589",
  "redux-less": "static-2.9538",
  "sequences-lib": "static-1.8138",
  "ui-gdpr-components": "static-1.10404",
  "products-ui-components": "static-1.40279",
  "accounting-integrations-ui-components": "static-1.7151",
  "invoices-ui-lib": "static-1.54904",
  "commerce-products-api": "static-1.2381",
  "invoices-iframe-lib": "static-1.56962",
  "quotes-modal-lib": "static-1.102898",
  "quotes-ui-lib": "static-1.80941",
  "stripe-connect-js": "static-1.69",
  "draft-content-plugins": "static-1.28416",
  "ContentData": "static-1.68600",
  "layout-data-lib": "static-1.9851",
  "hub-http-rxjs": "static-1.805",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3994",
  "billing-payments-client-types": "static-1.4046",
  "react-performance-metrics-lib": "static-1.611",
  "account-and-billing-fintech-outages": "static-3.18659",
  "pricing-pages-api": "static-1.14169",
  "ContentComponents": "static-2.71481",
  "marketing-contacts-lib": "static-1.10240",
  "marketing-email-service-types": "static-1.1938",
  "messaging-editing-lib": "static-1.46430",
  "messaging-usage-based-billing-components-lib": "static-1.1292",
  "automation-ui-source-apps": "static-1.19036",
  "automation-ui-types": "static-1.19954",
  "messaging-types-lib": "static-1.46167",
  "onboarding-settings-client": "static-1.4559",
  "sequences-client-types-lib": "static-1.7995",
  "commerce-tax-lib": "static-1.587",
  "price-books-api": "static-1.1029",
  "price-books-components": "static-1.1087",
  "property-description-translator": "static-1.3897",
  "ramp-editor": "static-1.275",
  "commerce-analytics-service-client": "static-1.3677",
  "totals-ui-components": "static-1.23758",
  "SalesContentIndexUI": "static-3.9332",
  "advanced-menus-core": "static-1.15214",
  "advanced-menus-lib": "static-1.12149",
  "ui-memberships-settings-lib": "static-1.34194",
  "segments-query-core": "static-1.1472",
  "eligibility-engine-service-types": "static-1.3238",
  "automation-ui-ubb": "static-1.5870",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7393",
  "data-token-views": "static-1.16483",
  "forms-utils-lib": "static-1.12687",
  "payments-embed-points-lib": "static-1.13149",
  "simple-menus-core": "static-1.15213",
  "simple-menus-lib": "static-1.16730",
  "videoconference-integration-components": "static-1.6904",
  "marketing-contacts-client": "static-1.7570",
  "automation-applications-service-types": "static-1.3557",
  "automation-platform-service-types": "static-1.2603",
  "ContentEditorUI": "static-2.77255",
  "short-messages-app-service-client": "static-1.4025",
  "web-interactives-components": "static-1.13853",
  "web-interactives-data": "static-1.13854",
  "messaging-shared-utils-lib": "static-1.741",
  "messaging-user-info-utils-lib": "static-1.911",
  "email-portal-health-service-types": "static-1.1033",
  "line-items-api": "static-1.782",
  "commerce-totals-service-types": "static-1.3860",
  "FireAlarmUi": "static-1.4554",
  "sales-templates-service-types-lib": "static-1.4211",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21890",
  "automation-ui-usage-tracking": "static-1.21353",
  "data-studio-ubb": "static-1.2880",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27161",
  "collaboration-sidebar": "static-1.57972",
  "content-management-data-lib": "static-1.5463",
  "copilot-plugins": "static-1.11254",
  "cta-picker": "static-1.36554",
  "customer-agent-discovery-components-lib": "static-1.3241",
  "editor-components": "static-1.13312",
  "editor-iframe-lib": "static-1.8483",
  "error-messaging-js": "static-1.5247",
  "FormsCommonComponents": "static-1.86002",
  "pictos": "static-7.185",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10701",
  "SharedLegalStrings": "static-1.1801",
  "smart-content-core": "static-1.42596",
  "smart-content-lib": "static-1.43249",
  "social-composer-lib": "static-1.59377",
  "structured-content-lib": "static-1.25341",
  "theme-previewer-lib": "static-1.53389",
  "tinymce-copilot": "static-1.16589",
  "xray-recommendation-lib": "static-1.7985",
  "automation-ui-routing": "static-1.21311",
  "sql-reporting-client-types": "static-1.5680",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42315",
  "campaigns-utils-lib": "static-1.3242",
  "reporting-enablement": "static-1.23117",
  "chatspot-widget-iframe": "static-1.21531",
  "collaboration-sidebar-common": "static-1.2769",
  "forms-ai-lib": "static-1.4402",
  "codemirror-dlb": "static-1.58814",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6487",
  "report-customization-components": "static-1.13320",
  "data-quality-ui-library": "static-1.13192",
  "reporting-filters": "static-1.470",
  "reporting-insights-lib": "static-1.1903"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12438",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.477",
  "data-fetching-client": "/data-fetching-client/static-1.9719",
  "foundations-components": "/foundations-components/static-1.8036",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1061",
  "foundations-theming": "/foundations-theming/static-1.4479",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8071",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10096",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11528",
  "I18n": "/I18n/static-7.1633",
  "jasmine-runner": "/jasmine-runner/static-1.6518",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12499",
  "quartz": "/quartz/static-1.7097",
  "react-dlb": "/react-dlb/static-1.80",
  "react-rhumb": "/react-rhumb/static-1.16733",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2913",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9725",
  "settings-ui-lib": "/settings-ui-lib/static-1.12574",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7241",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11206",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9596",
  "unified-auth": "/unified-auth/static-1.559",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.841",
  "usage-tracker": "/usage-tracker/static-1.7404",
  "usage-tracker-core": "/usage-tracker-core/static-1.7254",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8148",
  "hub-http": "/hub-http/static-1.6277",
  "integrations-lib": "/integrations-lib/static-1.16341",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19971",
  "property-management-iframe": "/property-management-iframe/static-1.13346",
  "quartz-config": "/quartz-config/static-1.875",
  "quartz-core": "/quartz-core/static-1.6316",
  "quartz-routing": "/quartz-routing/static-1.527",
  "quick-fetch": "/quick-fetch/static-1.3959",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4707",
  "ts-schema": "/ts-schema/static-1.4121",
  "ui-universal-auth": "/ui-universal-auth/static-1.9045",
  "UIComponents": "/UIComponents/static-3.8474",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3441",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3374",
  "quartz-webpack": "/quartz-webpack/static-1.3321",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.175",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4305",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4924",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2195",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9478",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5385",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2081",
  "ui-fonts": "/ui-fonts/static-1.790",
  "ui-images": "/ui-images/static-2.1165",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2962",
  "foundations-theming-base": "/foundations-theming-base/static-1.3464",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.765",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3182",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4380",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9106",
  "ai-rendering-library": "/ai-rendering-library/static-1.10360",
  "chirp-fetch": "/chirp-fetch/static-1.1942",
  "connections-embed-lib": "/connections-embed-lib/static-1.1099",
  "copilot-toolkit": "/copilot-toolkit/static-1.11281",
  "feedback-loader": "/feedback-loader/static-1.29397",
  "laboratory-lib": "/laboratory-lib/static-3.7210",
  "marketplace-embed": "/marketplace-embed/static-1.22246",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9866",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19926",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14141",
  "sanitize-text": "/sanitize-text/static-1.8198",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8758",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5818",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5090",
  "wootric-nps": "/wootric-nps/static-1.7023",
  "quartz-head": "/quartz-head/static-1.762",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4706",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4208",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2526",
  "reporting-data": "/reporting-data/static-1.67792",
  "cssUtils": "/cssUtils/static-1.804",
  "flux-actions": "/flux-actions/static-1.341",
  "HubStyle": "/HubStyle/static-2.11835",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10264",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10419",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7394",
  "icons": "/icons/static-2.650",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18503",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4568",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5519",
  "quartz-i18n": "/quartz-i18n/static-1.772",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.69",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.396",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.532",
  "slack-ui-library": "/slack-ui-library/static-1.10447",
  "fsm": "/fsm/static-1.3785",
  "customer-data-objects": "/customer-data-objects/static-1.7732",
  "property-translator": "/property-translator/static-1.5453",
  "hs-locale-management": "/hs-locale-management/static-1.122",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7981",
  "hs-promise-utils": "/hs-promise-utils/static-1.5646",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4932",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13756",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5660",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7836",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4531",
  "superstore": "/superstore/static-1.4815",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10269",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7971",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "hubspotter-http": "/hubspotter-http/static-1.4692",
  "immutable-less": "/immutable-less/static-1.4707",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17378",
  "nav-meta": "/nav-meta/static-1.29809",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10303",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18076",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3886",
  "property-management-common": "/property-management-common/static-1.5634",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9115",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.772",
  "quartz-test": "/quartz-test/static-1.772",
  "quartz-tracking": "/quartz-tracking/static-1.476",
  "trellis-components": "/trellis-components/static-1.2100",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.117",
  "bender-build-tools": "/bender-build-tools/static-1.3254",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21540",
  "ContentUtils": "/ContentUtils/static-1.68525",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13087",
  "sassPrefix": "/sassPrefix/static-1.157",
  "breeze-engine-core": "/breeze-engine-core/static-1.128",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.147",
  "avatar-components": "/avatar-components/static-1.2553",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39989",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13224",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14524",
  "ExportDialog": "/ExportDialog/static-6.10440",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41452",
  "reporting-snowflake": "/reporting-snowflake/static-1.56410",
  "reporting-ui-components": "/reporting-ui-components/static-2.65063",
  "reporting-visualizations": "/reporting-visualizations/static-1.59868",
  "ui-addon-teams": "/ui-addon-teams/static-1.21629",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.72",
  "magpie-lib": "/magpie-lib/static-1.5587",
  "navigation-components": "/navigation-components/static-1.18172",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.850",
  "magpie-types": "/magpie-types/static-1.5047",
  "simple-logging-lib": "/simple-logging-lib/static-1.3105",
  "ai-studio-lib": "/ai-studio-lib/static-1.11772",
  "app-governance-lib": "/app-governance-lib/static-1.1727",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10567",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8056",
  "ui-product-approvals": "/ui-product-approvals/static-1.28315",
  "ui-tool-access": "/ui-tool-access/static-1.10203",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9191",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5821",
  "usage-tracker-public": "/usage-tracker-public/static-1.7215",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3627",
  "persist-promise": "/persist-promise/static-1.3753",
  "reference-resolvers": "/reference-resolvers/static-1.8227",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3980",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.391",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3073",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2931",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "atom": "/atom/static-1.5129",
  "purchase-motions-components": "/purchase-motions-components/static-1.6017",
  "salesImages": "/salesImages/static-1.526",
  "batch-promise": "/batch-promise/static-1.1596",
  "crm-component-utils": "/crm-component-utils/static-1.39222",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5943",
  "customer-data-properties": "/customer-data-properties/static-1.51771",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6944",
  "property-value-citations": "/property-value-citations/static-1.2385",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8153",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9112",
  "navigation-messaging": "/navigation-messaging/static-1.7499",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10094",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.988",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4867",
  "content-icons-ui": "/content-icons-ui/static-1.2239",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9880",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7303",
  "crm-message-bus": "/crm-message-bus/static-1.43113",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22424",
  "events-data-lib": "/events-data-lib/static-1.284",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4775",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4046",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6849",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1038",
  "onboarding-tours": "/onboarding-tours/static-1.16707",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13836",
  "academy-common-lib": "/academy-common-lib/static-1.13984",
  "content-assistance-lib": "/content-assistance-lib/static-1.7836",
  "dashboard-lib": "/dashboard-lib/static-1.81760",
  "file-manager-components": "/file-manager-components/static-1.23767",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18573",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18382",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18374",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19921",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8760",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4817",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11111",
  "user-context": "/user-context/static-1.5162",
  "growth-payments-core": "/growth-payments-core/static-1.25535",
  "reporting-plugins": "/reporting-plugins/static-1.10408",
  "reporting-reports": "/reporting-reports/static-1.67470",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.778",
  "nest": "/nest/static-1.287",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10682",
  "framework-listing-lib": "/framework-listing-lib/static-2.28839",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30851",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4305",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.210",
  "onboarding-scopes": "/onboarding-scopes/static-1.6516",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4921",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7713",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15005",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3631",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9419",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6020",
  "signup-constants": "/signup-constants/static-1.18967",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8110",
  "card-properties-lib": "/card-properties-lib/static-1.44359",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37276",
  "crm-actions": "/crm-actions/static-1.6394",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43748",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9423",
  "customer-data-tracking": "/customer-data-tracking/static-1.6944",
  "hs-resources": "/hs-resources/static-1.224",
  "pulse": "/pulse/static-1.642",
  "calling-global-api": "/calling-global-api/static-1.64710",
  "calling-internal-common": "/calling-internal-common/static-1.31359",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66092",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58386",
  "commerce-products-lib": "/commerce-products-lib/static-1.9761",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3839",
  "crm-links": "/crm-links/static-1.6362",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4181",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4264",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.687",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3733",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48932",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4007",
  "smart-property-lib": "/smart-property-lib/static-1.7404",
  "tiered-pricing": "/tiered-pricing/static-1.1341",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11044",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.63",
  "react-dnd-compat": "/react-dnd-compat/static-1.4669",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1032",
  "growth-data-modal": "/growth-data-modal/static-1.5513",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3121",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2077",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.773",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7650",
  "academy-service-client": "/academy-service-client/static-1.3738",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39266",
  "FileManagerLib": "/FileManagerLib/static-1.39407",
  "video-embed": "/video-embed/static-1.35963",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28713",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11471",
  "video-data-lib": "/video-data-lib/static-1.35129",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8519",
  "payment-link-components": "/payment-link-components/static-1.23657",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9941",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24495",
  "viral-links-lib": "/viral-links-lib/static-1.7125",
  "data-token-picker": "/data-token-picker/static-1.16502",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.281",
  "timezone-utils": "/timezone-utils/static-2.5298",
  "seat-types-lib": "/seat-types-lib/static-1.145",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17691",
  "ui-addon-opt": "/ui-addon-opt/static-4.8417",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9256",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25570",
  "framework-data-table": "/framework-data-table/static-2.12044",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6917",
  "nudge-client-utils": "/nudge-client-utils/static-1.2702",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1132",
  "switchboard-lib": "/switchboard-lib/static-1.277",
  "app-users-service-client": "/app-users-service-client/static-1.5659",
  "app-users-service-types": "/app-users-service-types/static-1.5067",
  "mini-checkout-client": "/mini-checkout-client/static-1.26942",
  "onboarding-utils": "/onboarding-utils/static-1.5412",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2054",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28698",
  "edison-service-client-types": "/edison-service-client-types/static-1.444",
  "crm_data": "/crm_data/static-4.92141",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46168",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16522",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4313",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19254",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18666",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10523",
  "crm-fe-perf": "/crm-fe-perf/static-1.22957",
  "event-emitter": "/event-emitter/static-1.1003",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.145",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31366",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11091",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6596",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1221",
  "commerce-permissions": "/commerce-permissions/static-1.829",
  "products-iframe-lib": "/products-iframe-lib/static-1.8087",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10478",
  "data-agent-kit": "/data-agent-kit/static-1.281",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10179",
  "policy-lib": "/policy-lib/static-1.6833",
  "react-tinymce": "/react-tinymce/static-1.55395",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10242",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54521",
  "tinymce-plugins": "/tinymce-plugins/static-1.57635",
  "tinymce-themes": "/tinymce-themes/static-1.56491",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2054",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2105",
  "user-context-client": "/user-context-client/static-1.4655",
  "audio-components": "/audio-components/static-1.5995",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36918",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4592",
  "video-components": "/video-components/static-1.13473",
  "outpost": "/outpost/static-1.4230",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6634",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12539",
  "content-media-compositions": "/content-media-compositions/static-2.16546",
  "media-bridge-lib": "/media-bridge-lib/static-1.19019",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6204",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5135",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3689",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21770",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3902",
  "ts-utils-lib": "/ts-utils-lib/static-1.226",
  "crm-export-dialog": "/crm-export-dialog/static-1.6345",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6497",
  "crm-view-components": "/crm-view-components/static-1.439",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7383",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2459",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2778",
  "whisper-core-api": "/whisper-core-api/static-1.6777",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14962",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5675",
  "settings-content-modals": "/settings-content-modals/static-1.46242",
  "crm_universal": "/crm_universal/static-1.22102",
  "customer-data-email": "/customer-data-email/static-1.18129",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37327",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39699",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12289",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54888",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21618",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18044",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72220",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5399",
  "utility-belt": "/utility-belt/static-1.2589",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23040",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7603",
  "customer-data-rte": "/customer-data-rte/static-1.33144",
  "cv-backend-services": "/cv-backend-services/static-1.1555",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5838",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5163",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38310",
  "trials-service-types": "/trials-service-types/static-1.3957",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35998",
  "sales-views-client-types": "/sales-views-client-types/static-1.4312",
  "hub-http-contrib": "/hub-http-contrib/static-1.3096",
  "interframe": "/interframe/static-3.4814",
  "tinymce-data": "/tinymce-data/static-1.40606",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5265",
  "layout-dnd-components": "/layout-dnd-components/static-1.12551",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11526",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15493",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9100",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7659",
  "social-insights-client-types": "/social-insights-client-types/static-1.22241",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4211",
  "checkout-sdk": "/checkout-sdk/static-3.23785",
  "checkout-service-types": "/checkout-service-types/static-1.3846",
  "company-details-components": "/company-details-components/static-1.6250",
  "payment-method-components": "/payment-method-components/static-1.6949",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14304",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3520",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3576",
  "access-control-lib": "/access-control-lib/static-1.10489",
  "EmailComponents": "/EmailComponents/static-1.54912",
  "EmailData": "/EmailData/static-1.53589",
  "redux-less": "/redux-less/static-2.9538",
  "sequences-lib": "/sequences-lib/static-1.8138",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10404",
  "products-ui-components": "/products-ui-components/static-1.40279",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7151",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54904",
  "commerce-products-api": "/commerce-products-api/static-1.2381",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56962",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102898",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80941",
  "stripe-connect-js": "/stripe-connect-js/static-1.69",
  "draft-content-plugins": "/draft-content-plugins/static-1.28416",
  "ContentData": "/ContentData/static-1.68600",
  "layout-data-lib": "/layout-data-lib/static-1.9851",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.805",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3994",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4046",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.611",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18659",
  "pricing-pages-api": "/pricing-pages-api/static-1.14169",
  "ContentComponents": "/ContentComponents/static-2.71481",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10240",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1938",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46430",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1292",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19036",
  "automation-ui-types": "/automation-ui-types/static-1.19954",
  "messaging-types-lib": "/messaging-types-lib/static-1.46167",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4559",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7995",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.587",
  "price-books-api": "/price-books-api/static-1.1029",
  "price-books-components": "/price-books-components/static-1.1087",
  "property-description-translator": "/property-description-translator/static-1.3897",
  "ramp-editor": "/ramp-editor/static-1.275",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3677",
  "totals-ui-components": "/totals-ui-components/static-1.23758",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9332",
  "advanced-menus-core": "/advanced-menus-core/static-1.15214",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12149",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34194",
  "segments-query-core": "/segments-query-core/static-1.1472",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3238",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5870",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7393",
  "data-token-views": "/data-token-views/static-1.16483",
  "forms-utils-lib": "/forms-utils-lib/static-1.12687",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13149",
  "simple-menus-core": "/simple-menus-core/static-1.15213",
  "simple-menus-lib": "/simple-menus-lib/static-1.16730",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6904",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7570",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3557",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2603",
  "ContentEditorUI": "/ContentEditorUI/static-2.77255",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4025",
  "web-interactives-components": "/web-interactives-components/static-1.13853",
  "web-interactives-data": "/web-interactives-data/static-1.13854",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.741",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.911",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1033",
  "line-items-api": "/line-items-api/static-1.782",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3860",
  "FireAlarmUi": "/FireAlarmUi/static-1.4554",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4211",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21890",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21353",
  "data-studio-ubb": "/data-studio-ubb/static-1.2880",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27161",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57972",
  "content-management-data-lib": "/content-management-data-lib/static-1.5463",
  "copilot-plugins": "/copilot-plugins/static-1.11254",
  "cta-picker": "/cta-picker/static-1.36554",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3241",
  "editor-components": "/editor-components/static-1.13312",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8483",
  "error-messaging-js": "/error-messaging-js/static-1.5247",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86002",
  "pictos": "/pictos/static-7.185",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10701",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1801",
  "smart-content-core": "/smart-content-core/static-1.42596",
  "smart-content-lib": "/smart-content-lib/static-1.43249",
  "social-composer-lib": "/social-composer-lib/static-1.59377",
  "structured-content-lib": "/structured-content-lib/static-1.25341",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53389",
  "tinymce-copilot": "/tinymce-copilot/static-1.16589",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7985",
  "automation-ui-routing": "/automation-ui-routing/static-1.21311",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5680",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42315",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3242",
  "reporting-enablement": "/reporting-enablement/static-1.23117",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21531",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2769",
  "forms-ai-lib": "/forms-ai-lib/static-1.4402",
  "codemirror-dlb": "/codemirror-dlb/static-1.58814",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6487",
  "report-customization-components": "/report-customization-components/static-1.13320",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13192",
  "reporting-filters": "/reporting-filters/static-1.470",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1903"
}
};
